import React from "react";
import MultiDropDown from "../Components/MultiDropdown";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import swal from "sweetalert";
import axios from "axios";
import SopCreate from "../SOP/CreateSopShortCut";
import { BackIcon } from "../../assets/Icons";

class ListWorkflow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // checkedUser: [],
      creatingWorkflow: false,
      // selectedType: [],
      typeHierarchy: [],
      sop: "",
      title: "",
      description: "",
      version: "",
      workflow_unique_id: "",
      addMoreSop: "",
      errors: {
        title: "",
        sop: "",
        description: "",
        // selectedType: "",
        version: "",
        workflow_unique_id: "",
        // support_user_id: ''
      },
    };
  }

  checkRequirement = (name, value) => {
    let errors = this.state.errors;

    switch (name) {
      case "title":
        errors.title = value.length < 1 ? "Please Fill Out This Field !" : "";
        break;
      case "sop":
        errors.sop = value.length < 1 || value == "Select" || value == "AddMore" ? "Please Fill Out This Field !" : "";
        break;
      case "sop2":
        errors.sop = value.length < 1 || value == "Select" || value == "AddMore" ? "Please Fill Out This Field !" : "";
        break;

      case "description":
        errors.description = value.length < 1 ? "Please Fill Out This Field !" : "";
        break;
      case "version":
        errors.version =
          value.split(".").length != 2
            ? "Please fill the correct version. e.g 1.0. "
            : value.split(".")[0] == "" || value.split(".")[1] == ""
            ? "Please fill the correct version. e.g 1.0. "
            : "";
        break;
      // case "selectedType":
      //   errors.selectedType = this.state.selectedType.length < 1 ? "Please Select The Types" : "";
      //   break;
      // case 'support_user_id':
      //     errors.support_user_id =
      //         this.state.checkedUser.length < 1
      //             ? 'Please Select The User'
      //             : '';
      //     break;
      case "workflow_unique_id":
        errors.workflow_unique_id = value.length < 1 ? "Please Fill Out This Field !" : "";
        break;
      default:
        break;
    }

    this.setState({ errors });
  };

  onChangeInput = (e) => {
    e.preventDefault();

    this.checkRequirement(e.target.name, e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeInputDropDown = (e) => {
    e.preventDefault();
    if (e.target.value == "AddMore") {
      this.setState({ addMoreSop: true });
    }else{
      this.setState({ [e.target.name]: e.target.value });
      this.checkRequirement(e.target.name, e.target.value);
    }
  };

  componentDidMount() {
    // this.getTotalType();
    // this.getSopList();
    // this.getUserList();
  }

  convert = (array) => {
    var map = {};
    for (var i = 0; i < array.length; i++) {
      var obj = array[i];
      obj.children = [];

      map[obj.id] = obj;

      var parent_id = obj.parent_id || "-";
      if (!map[parent_id]) {
        map[parent_id] = {
          children: [],
        };
      }
      map[parent_id].children.push(obj);
    }

    return map["-"].children;
  };
  // getSopList = () => {
  //   var data = {
  //     groupId  :this.props.userDetails?.user?.group?.uuid
  //   };
  //   let _this = this;
  //   let headers = {
  //     user_id: ud.id.toString(),
  //     session_id: ud.session_id.toString(),
  //     user_type: ud.usertype.toString(),
  //     main_id: ud.main_id.toString(),
  //     jwt_token: jwt,
  //     c_id: ud.c_id.toString(),
  //   };
  //   axios
  //     .post(`${SERVER_IP}/SOP/SOPList`, data, { withCredentials: true, headers: headers })
  //     .then(function (response) {
  //       if (response.data.error === false) {
  //         if (response.data.SOP) {
  //           _this.setState({ SOPList: response.data.SOP });
  //         }
  //       } else {
  //         auth_response_flow(response.data, (return_response) => {
  //           if (return_response.error === false && return_response.retry === true) {
  //             _this.getSopList();
  //           }
  //         });
  //       }
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  submit = async(e) => {
    e.preventDefault();

    Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]));

    if (!validateForm(this.state.errors)) {
      // swal("Error", "Invalid Input ..!!", "error");
      return;
    }

    var getselected = [];
    // this.state.selectedType.map((list, index) => getselected.push(list.id));

    // var selectedUser = [];
    // this.state.checkedUser.map((list, index) => selectedUser.push(list.value))

    var data = {
      title: this.state.title,
      description: this.state.description,
      version: this.state.version,
      workflow_unique_id: this.state.workflow_unique_id,

      typeid: getselected,
      sop_id: this.state.sop,
      sid: ud.main_id,
      user_uuid: this.props.userDetails?.user?.uuid,
      // support_user_id: selectedUser
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    try {
      let response = await axios.post(`${SERVER_IP}/workflow/create`, data, { withCredentials: true, headers: headers });
      if (response.data.error === false) {
        swal("Success", response.data.message, "success");
        this.props.handleCloseWorkflow();
        this.props.getWorkflowList();
        setTimeout(() => {
          swal.close();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
       swal("Error", "Something Went Wrong. Please Retry.", "error");
    }

  };

  getTotalType = () => {
    var data = {
      jwt: jwt,
      s_id: ud.main_id,
    };
    let _this = this;
    var heirarchy = this.state.heirarchy;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/view/typesfordropdown`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          var r = _this.convert(response.data.result.result);
          // var r = _this.convert(heirarchy)

          var temparr = [];
          r.map((list, index) => {
            temparr.push([]);
          });
          // _this.setState({ typeHierarchy: r, dynamicSelectedType: temparr });
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getTotalType();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  onChangeDropdown = (index, currentNode, selectedNodes) => {
    // this.setState({ selectedType: selectedNodes });
  };
  getUserList = () => {
    // User List
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    var data = {
      s_id: ud.main_id,
      user_id: "",
      user_type: ud.usertype,
    };
    axios
      .post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.usersList) {
            const arr = [];
            response.data.usersList.forEach((element) => {
              arr.push({ label: element.name, value: element.id });
            });
            _this.setState({ usersList: arr });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  closeEvent = () => {
    this.setState({ addMoreSop: false });
    this.props.getSopList();
  };

  render() {
    const { errors } = this.state;
    return (
      <>
        {this.state.addMoreSop ? (
          <div>
            <div className="d-flex align-items-center gap-1 mb-2 pt-3">
              <button className="backbtndes" onClick={() => this.setState({ addMoreSop: false })}>
                <BackIcon />
              </button>
              <h5 className="card-title">Create New Workflow Type</h5>
            </div>
            <SopCreate userDetails={this.props.userDetails} closeEvent={this.closeEvent} />
          </div>
        ) : (
          <div>
            <div className="form-group ">
              <label for="exampleInputEmail1">
                Title <i class="text-danger">*</i>
              </label>
              <input
                type="text"
                onChange={this.onChangeInput}
                name="title"
                className="form-control"
                value={this.state.title}
                placeholder="Enter Title"
              />
              {errors.title.length > 0 && <span className="text-danger">{errors.title}</span>}
            </div>
            <div className="form-row  d-flex align-items-center">
              <div className="form-group col-md-6">
                <label for="exampleInputEmail1">
                  Version <i class="text-danger">*</i>
                </label>
                <input
                  type="number"
                  step="0.1"
                  onChange={this.onChangeInput}
                  name="version"
                  value={this.state.version}
                  className="form-control"
                  placeholder="Enter Version"
                />
                {errors.version.length > 0 && <span className="text-danger">{errors.version}</span>}
              </div>
              <div className="form-group col-md-6">
                <label for="exampleInputEmail1">
                  Workflow ID <i class="text-danger">*</i>
                </label>
                <input
                  type="text"
                  step="0.1"
                  onChange={this.onChangeInput}
                  name="workflow_unique_id"
                  value={this.state.workflow_unique_id}
                  className="form-control"
                  placeholder="Enter Workflow ID"
                />
                {errors.workflow_unique_id.length > 0 && (
                  <span className="text-danger">{errors.workflow_unique_id}</span>
                )}
              </div>
            </div>
            <div className="form-group">
              <label for="exampleInputEmail1">
                Description <i class="text-danger">*</i>
              </label>
              <textarea
                type="text"
                onChange={this.onChangeInput}
                name="description"
                className="form-control"
                value={this.state.description}
                placeholder="Enter Description"
              />
              {errors.description.length > 0 && <span className="text-danger">{errors.description}</span>}
            </div>
            <div className="form-row d-flex align-items-center gap-2">
              <div className="form-group col-md-6">
                <label for="exampleInputEmail1">
                  Select Workflow Type <i class="text-danger">*</i>
                </label>

                {/* <div>
                  <select name="sop" className="form-control" onChange={this.onChangeInputDropDown}>
                    <option value="1" className="sky" style={{ color: "#2f3a79" }}>
                      {" "}
                      + Create New Type{" "}
                    </option>
                    <option value="2">Title 1 </option>
                    <option value="3">Title 2 </option>
                    <option value="3">Title 3 </option>
                  </select>
                </div>
                {errors.sop.length > 0 && <span className="text-danger">{errors.sop}</span>} */}

                <select name="sop" className="form-control" onChange={this.onChangeInputDropDown}>
                  <option value="Select" className="sky" style={{ color: "#2f3a79" }}>
                    Select
                  </option>
                  <option value="AddMore" style={{ color: "#2F3A79", fontWeight: "bold" }}>
                    + Create New Type
                  </option>
                  {(this.props.SOPList || []).map((list, index) => (
                    <option value={list.id}>{list.sop_type_name}</option>
                  ))}
                </select>
                {errors.sop.length > 0 && <span className="text-danger">{errors.sop}</span>}
              </div>

              {/* <div
                className="form-group col-md-6
              "
              >
                <label for="exampleInputEmail1">
                  Map Workflow <i class="text-danger">*</i>
                </label>
                <div>
                  <MultiDropDown index={0} data={this.state.typeHierarchy} onChange={this.onChangeDropdown} />
                </div>
                {errors.selectedType.length > 0 && <span className="text-danger">{errors.selectedType}</span>}
              </div> */}
            </div>
            <button onClick={this.submit} className="btn btn-primary mb-2 mt-2">
              Save
            </button>
          </div>
        )}
      </>
    );
  }
}
export default ListWorkflow;

const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
  return valid;
};
